import Contact from '@/modules/help/Contact.vue';
import Privacy from "@/modules/documents/Privacy.vue";
import Terms from "@/modules/documents/Terms.vue";

export default [
    {
        path: '/contact',
        name: 'Contact',
        component: Contact,
        meta: { requiresNavbar: true },
    }, {
        path: '/privacy',
        name: 'Privacy',
        component: Privacy,
        meta: { requiresNavbar: true },
    }, {
        path: '/terms-conditions',
        name: 'Terms',
        component: Terms,
        meta: { requiresNavbar: true },
    },
];
